<lib-dlg titulo="Jutificativa de recusa de item da Requisição" nome="dlgRecusadoRequisicao" [visualizar]="visualizar"
  (onHide)="onHide()" styleClassHeader="text-white bg-danger">
  <div class="row" *ngIf="motivos && motivos.length > 0">
    <div class="col-md-12">
      <label for="motivo_exclusao">
        Necessario informar a jutificativa de recusa para o item <b
          style="font-size: 12px;">{{motivos[index].produto_unidade.produto.nome}}</b>.
        <span class="text-danger">*</span>
      </label>
      <textarea [(ngModel)]="motivos[index].justificativa_recusado" class="form-control" id="justificativa_recusado"
        rows="3"></textarea>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-sm-12">
      <p-checkbox [(ngModel)]="mesmaJustificativa" [binary]="false"></p-checkbox>
      <span class="ml-2">Usar a mesma jutificativa para
        os demais itens
        recusado?</span>
    </div>
  </div>
  <ng-container opcoes>
    <button (click)="proximo()" type="submit" class="btn btn-danger btn-sm float-right ml-2">{{validFinalizar() ?
      'Finalizar' : 'Proximo'}}</button>
  </ng-container>
</lib-dlg>